import { useEffect } from "react";
import { usePermission } from "./usePermission";

export function usePermissionCheck(
  rule: string,
  facilitiesorId: any,
  callback?: Function
) {
  const { isPermitted } = usePermission();

  useEffect(() => {
    let _hasPermission = false;

    if (Array.isArray(facilitiesorId)) {
      for (const facility of facilitiesorId) {
        if (isPermitted(rule, facility.facilityId)) {
          _hasPermission = true;
          break;
        }
      }
    } else {
      _hasPermission = isPermitted(rule, facilitiesorId);
    }

    if (callback) callback(_hasPermission);
  }, [rule, facilitiesorId, callback]);
}
